import dayjs from "dayjs";
import "dayjs/locale/de";
import "dayjs/locale/es";
import "dayjs/locale/fr";
import "dayjs/locale/it";
import localeData from "dayjs/plugin/localeData";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { formatToBusinessHoursInput } from "./timerHelper";
import { normalizeLocale } from "./locale";

import { TimeFormat as ClockTimeFormat } from "@/types/time";
import { EventTimeFormat } from "@/types/qr";
import { LanguageCode } from "@/types/languages";

dayjs.extend(localeData);
dayjs.extend(localizedFormat);

export const convertTimeFormatToClockFormat = (timeFormat: EventTimeFormat): ClockTimeFormat => {
  switch (timeFormat) {
    case "24-HOURS":
      return "24";
    case "AM-PM":
      return "AM/PM";
    default:
      return "AM/PM";
  }
};

export const getPreviewFormattedDateString = (date: string, locale?: LanguageCode): string => {
  if (!date || !dayjs(date).isValid()) return "";

  const dayjsLocale = locale ? normalizeLocale(locale) : "en";
  const localizedDayjs = dayjs(date).locale(dayjsLocale);

  const dayName = localizedDayjs.localeData().weekdays()[localizedDayjs.day()];
  const month = localizedDayjs.localeData().months()[localizedDayjs.month()];
  const dayNumber = localizedDayjs.date();
  const year = localizedDayjs.year();

  return `${dayName}, ${month} ${dayNumber}, ${year}`;
};

export const getPreviewFormattedTimeString = (
  startTime: string,
  endTime: string,
  format: EventTimeFormat = "AM-PM"
): string => {
  if (!startTime && !endTime) return "";

  const formattedStartTime =
    formatToBusinessHoursInput(startTime, convertTimeFormatToClockFormat(format))?.toUpperCase() ||
    "";
  const formattedEndTime =
    formatToBusinessHoursInput(endTime, convertTimeFormatToClockFormat(format))?.toUpperCase() ||
    "";

  return `${formattedStartTime} - ${formattedEndTime}`;
};

export const staticPageFormatDateByLocale = (dateString: string, locale: string) => {
  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return "Invalid date";
  }

  const options = {
    month: "long",
    year: "numeric",
  } as Intl.DateTimeFormatOptions;

  return new Intl.DateTimeFormat(locale, options).format(date);
};

export const formatLongDate = (
  date: string | Date | undefined | null,
  locale?: LanguageCode | null
): string => {
  if (!date) return "";

  const dayjsLocale = locale ? normalizeLocale(locale) : "en";
  return dayjs(date).locale(dayjsLocale).format("LL");
};
